export const movies = [
  {
    id: "movie-1",
    type: "movie",
    title: "星际边界",
    image: "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20design%20with%20a%20lone%20astronaut%20silhouette%20before%20a%20giant%20glowing%20blue%20planet%2C%20deep%20navy%20tones%20with%20warm%20orange%20rim%20light%2C%20minimal%20clean%20dark%20background%2C%20dramatic%20lighting%2C%20highly%20detailed%20professional%20film%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=movie-01-poster&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=epic%20science%20fiction%20film%20backdrop%20of%20a%20vast%20star%20field%20with%20a%20colossal%20space%20station%20orbiting%20a%20deep%20blue%20planet%2C%20cinematic%20volumetric%20light%20and%20orange%20engine%20glow%2C%20dark%20navy%20color%20grading%2C%20wide%20dramatic%20composition%2C%20highly%20detailed%20digital%20matte%20painting&width=1600&height=900&seq=movie-01-cover&orientation=landscape",
    rating: 8.7,
    year: "2026",
    releaseDate: "2026-06-18",
    region: "中国大陆",
    genres: ["科幻", "冒险"],
    cast: "陆沉舟、白霜、周允",
    director: "陈之遥",
    duration: "148分钟",
    summary: "一支深空探测队跨越星际边界，却在未知星域发现了本不该存在的人类造物。",
    content: [
      "公元2147年，人类第一支载人深空探测队「远航号」跨越太阳系边界，向着半人马座方向航行。然而当飞船抵达预定坐标时，船员们发现了一座远超人类技术水平的神秘空间站。",
      "随着调查深入，队长陆沉舟逐渐意识到，这座空间站隐藏着一段被刻意抹去的文明记忆，而他们此行的真正目的，或许从出发那一刻起就已被改写。",
      "影片以冷峻的深蓝色调与恢弘的视听语言，探讨了人性、孤独与文明延续的命题，被誉为年度最具野心的科幻力作。",
    ],
    tags: ["科幻", "深空", "年度大片"],
  },
  {
    id: "movie-2",
    type: "movie",
    title: "暗夜追凶",
    image: "https://readdy.ai/api/search-image?query=noir%20crime%20thriller%20movie%20poster%20featuring%20a%20detective%20in%20a%20rain%20soaked%20alley%20with%20a%20single%20street%20lamp%2C%20deep%20navy%20and%20amber%20highlights%2C%20moody%20shadowy%20minimal%20background%2C%20dramatic%20lighting%2C%20professional%20film%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=movie-02-poster&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20noir%20city%20at%20night%20with%20wet%20reflective%20streets%20and%20warm%20amber%20street%20lamps%20cutting%20through%20deep%20blue%20fog%2C%20detective%20silhouette%20in%20distance%2C%20dark%20moody%20color%20grading%2C%20wide%20dramatic%20composition%2C%20highly%20detailed%20cinematography&width=1600&height=900&seq=movie-02-cover&orientation=landscape",
    rating: 8.3,
    year: "2026",
    releaseDate: "2026-05-02",
    region: "中国大陆",
    genres: ["悬疑", "犯罪"],
    cast: "顾长风、林知夏",
    director: "许砚",
    duration: "126分钟",
    summary: "连环悬案尘封十年后重启，刑警为追寻真相一步步走进自己布下的迷局。",
    content: [
      "十年前的一桩连环凶案因证据不足草草结案，办案刑警顾长风始终无法释怀。当相似的作案手法再次出现，他主动请缨重启调查。",
      "线索指向一个所有人都忽略的角落，真相每逼近一步，顾长风就越发怀疑自己当年是否放走了真正的凶手。",
      "影片以湿冷雨夜与暖黄灯光构建出独特的视觉张力，在类型片框架下完成了对正义与执念的深刻叩问。",
    ],
    tags: ["悬疑", "犯罪", "口碑佳作"],
  },
  {
    id: "movie-3",
    type: "movie",
    title: "城市之光",
    image: "https://readdy.ai/api/search-image?query=warm%20urban%20drama%20movie%20poster%20of%20a%20young%20man%20standing%20on%20a%20rooftop%20overlooking%20a%20glowing%20skyline%20at%20dusk%2C%20deep%20navy%20sky%20with%20warm%20orange%20window%20lights%2C%20minimal%20clean%20composition%2C%20dramatic%20lighting%2C%20professional%20film%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=movie-03-poster&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=panoramic%20city%20skyline%20at%20blue%20hour%20with%20thousands%20of%20warm%20orange%20window%20lights%2C%20deep%20navy%20evening%20sky%2C%20cinematic%20warm%20and%20cool%20contrast%2C%20wide%20emotional%20composition%2C%20highly%20detailed%20urban%20photography&width=1600&height=900&seq=movie-03-cover&orientation=landscape",
    rating: 7.9,
    year: "2025",
    releaseDate: "2025-12-12",
    region: "中国大陆",
    genres: ["剧情", "都市"],
    cast: "江野、苏晚",
    director: "梁映",
    duration: "118分钟",
    summary: "两个在都市中漂泊的年轻人，因一盏未关的窗灯而彼此照亮。",
    content: [
      "深夜的写字楼里，加班到崩溃的江野与独自守着便利店的苏晚，因为一次偶然的停电相遇。",
      "在这座巨大而冷漠的城市里，两个孤独的灵魂开始分享彼此的秘密，也慢慢学会与生活的疲惫和解。",
      "影片用细腻的镜头语言记录了平凡人的日常，被观众称为「写给都市漂流者的一封温柔情书」。",
    ],
    tags: ["剧情", "治愈", "现实主义"],
  },
  {
    id: "movie-4",
    type: "movie",
    title: "幻境奇缘",
    image: "https://readdy.ai/api/search-image?query=fantasy%20adventure%20movie%20poster%20with%20a%20mysterious%20glowing%20forest%20path%20and%20floating%20lanterns%2C%20deep%20navy%20night%20with%20warm%20orange%20magical%20light%2C%20dreamy%20minimal%20background%2C%20dramatic%20lighting%2C%20professional%20film%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=movie-04-poster&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=enchanting%20magical%20forest%20with%20towering%20glowing%20trees%20and%20hundreds%20of%20floating%20warm%20lanterns%2C%20deep%20blue%20twilight%20atmosphere%2C%20cinematic%20fantasy%20color%20grading%2C%20wide%20enchanting%20composition%2C%20highly%20detailed%20concept%20art&width=1600&height=900&seq=movie-04-cover&orientation=landscape",
    rating: 8.0,
    year: "2025",
    releaseDate: "2025-10-01",
    region: "中国大陆",
    genres: ["奇幻", "爱情"],
    cast: "叶知秋、沈砚之",
    director: "温梧",
    duration: "132分钟",
    summary: "一个能进入他人梦境的少女，在幻境中遇见了唯一看不见梦的人。",
    content: [
      "少女叶知秋拥有进入他人梦境的能力，却始终无法治愈自己的失眠。直到她遇见了沈砚之——一个从无梦境的人。",
      "为了探寻原因，两人一同踏入层层幻境，在虚实交错之间，逐渐找回了彼此遗落的记忆。",
      "影片的美术设计与光影运用极具想象力，用一场绚烂的梦境讲述了关于遗忘与铭记的故事。",
    ],
    tags: ["奇幻", "爱情", "视觉盛宴"],
  },
  {
    id: "movie-5",
    type: "movie",
    title: "风暴救援",
    image: "https://readdy.ai/api/search-image?query=action%20disaster%20movie%20poster%20of%20a%20rescue%20helicopter%20flying%20into%20a%20massive%20storm%20over%20rough%20seas%2C%20deep%20navy%20clouds%20with%20orange%20warning%20light%2C%20dramatic%20minimal%20background%2C%20high%20contrast%20lighting%2C%20professional%20film%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=movie-05-poster&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=apocalyptic%20ocean%20storm%20with%20giant%20waves%20and%20a%20rescue%20ship%20battling%20the%20tempest%2C%20deep%20navy%20sky%20with%20warm%20orange%20rescue%20flares%2C%20cinematic%20disaster%20color%20grading%2C%20wide%20intense%20composition%2C%20highly%20detailed%20digital%20art&width=1600&height=900&seq=movie-05-cover&orientation=landscape",
    rating: 8.5,
    year: "2026",
    releaseDate: "2026-07-20",
    region: "中国大陆",
    genres: ["动作", "灾难"],
    cast: "贺峰、米娜、赵岩",
    director: "郑海",
    duration: "135分钟",
    summary: "超强风暴逼近近海，一支民间救援队逆风而行，与时间争夺每一条生命。",
    content: [
      "气象预警显示，十年一遇的超强台风将在三十六小时后登陆。当官方救援通道被切断，一支民间救援队决定独自出海。",
      "队长贺峰带着队员们穿越惊涛骇浪，在一次次几乎不可能的营救中，他们也在与各自的心魔搏斗。",
      "影片实景拍摄了大量海上风暴场面，紧张到令人窒息的节奏让观众全程屏息。",
    ],
    tags: ["动作", "灾难", "暑期档"],
  },
  {
    id: "movie-6",
    type: "movie",
    title: "时光信笺",
    image: "https://readdy.ai/api/search-image?query=romantic%20drama%20movie%20poster%20with%20an%20old%20letter%20and%20a%20vintage%20clock%20under%20warm%20desk%20lamp%20light%2C%20deep%20navy%20shadow%20background%20with%20orange%20glow%2C%20nostalgic%20minimal%20composition%2C%20soft%20cinematic%20lighting%2C%20professional%20film%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=movie-06-poster&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=warm%20nostalgic%20study%20room%20with%20stacks%20of%20old%20letters%20and%20sunlight%20streaming%20through%20a%20window%2C%20deep%20blue%20shadows%20with%20orange%20afternoon%20light%2C%20cinematic%20romantic%20color%20grading%2C%20wide%20emotional%20composition%2C%20highly%20detailed%20interior&width=1600&height=900&seq=movie-06-cover&orientation=landscape",
    rating: 7.6,
    year: "2025",
    releaseDate: "2025-11-11",
    region: "中国大陆",
    genres: ["爱情", "剧情"],
    cast: "温言、程霄",
    director: "苏棂",
    duration: "112分钟",
    summary: "一封寄错年代的信，让两个相隔二十年的人有了交集。",
    content: [
      "整理老屋时，程霄发现了一个旧邮筒，投进去的信竟能在二十年前的信箱里出现。",
      "抱着试探的心情，他与过去的女孩温言开始了跨越时空的通信，两段人生因此产生了微妙的牵绊。",
      "影片温柔而克制，用最朴素的方式讲述了关于遗憾与释怀的故事。",
    ],
    tags: ["爱情", "剧情", "温情"],
  },
  {
    id: "movie-7",
    type: "movie",
    title: "深海归途",
    image: "https://readdy.ai/api/search-image?query=adventure%20movie%20poster%20of%20a%20tiny%20submarine%20descending%20into%20a%20glowing%20deep%20sea%20trench%2C%20deep%20navy%20water%20with%20orange%20bioluminescent%20creatures%2C%20mysterious%20minimal%20background%2C%20dramatic%20lighting%2C%20professional%20film%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=movie-07-poster&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=deep%20ocean%20trench%20illuminated%20by%20glowing%20orange%20bioluminescent%20life%20with%20a%20small%20explorer%20submarine%20in%20the%20vast%20deep%20blue%20darkness%2C%20cinematic%20underwater%20color%20grading%2C%20wide%20majestic%20composition%2C%20highly%20detailed%20concept%20art&width=1600&height=900&seq=movie-07-cover&orientation=landscape",
    rating: 8.2,
    year: "2026",
    releaseDate: "2026-03-14",
    region: "中国大陆",
    genres: ["冒险", "科幻"],
    cast: "海岩、黎青",
    director: "欧阳澈",
    duration: "124分钟",
    summary: "为寻找失踪的科考船，深潜队坠入万米海沟，揭开了海洋最深处的秘密。",
    content: [
      "一艘科考船在太平洋深处失联，深潜员海岩带队前往搜救，却在一场海底地震中被卷入万米海沟。",
      "在几乎不可能生还的环境里，他们发现了这片黑暗海域中令人震撼的生命奇观。",
      "影片耗时四年打造水下视效，让观众得以窥见地球最后的未知疆域。",
    ],
    tags: ["冒险", "科幻", "视效大片"],
  },
  {
    id: "movie-8",
    type: "movie",
    title: "无声证词",
    image: "https://readdy.ai/api/search-image?query=tense%20thriller%20movie%20poster%20of%20a%20silent%20empty%20courtroom%20with%20a%20single%20glowing%20evidence%20light%2C%20deep%20navy%20shadows%20with%20orange%20spotlight%2C%20minimal%20suspenseful%20background%2C%20dramatic%20lighting%2C%20professional%20film%20key%20art%2C%20vertical%20composition&width=600&height=900&seq=movie-08-poster&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=moody%20courtroom%20interior%20with%20deep%20blue%20shadows%20and%20a%20dramatic%20orange%20shaft%20of%20light%20across%20empty%20seats%2C%20cinematic%20tension%20color%20grading%2C%20wide%20suspenseful%20composition%2C%20highly%20detailed%20interior%20photography&width=1600&height=900&seq=movie-08-cover&orientation=landscape",
    rating: 8.8,
    year: "2026",
    releaseDate: "2026-04-26",
    region: "中国大陆",
    genres: ["悬疑", "剧情"],
    cast: "柯明、许静",
    director: "方寸",
    duration: "130分钟",
    summary: "一桩没有目击者的案件，让律师在沉默中寻找那份被消音的真相。",
    content: [
      "年轻律师柯明接手了一桩看似铁证如山的案件，唯一的疑点，是所有证人都选择了沉默。",
      "在压力与威胁之中，他坚持还原每一个细节，却发现沉默背后藏着远比案件更复杂的秘密。",
      "影片以冷静克制的叙事与出色的群像表演，探讨了真相、良知与代价。",
    ],
    tags: ["悬疑", "剧情", "高口碑"],
  },
];